<template>
  <!--lxf-->
  <div class="components-task-console" v-if="isShow">
    <div class="console__switch-button" @click="onShowDrawer">任务中心</div>
    <a-drawer
      title="任务中心"
      placement="right"
      width="500"
      :closable="false"
      :visible="$store.state.listAllPerm.showTaskConsoleDrawer"
      @close="onClosedDrawer"
    >
      <div class="console__drawer-head">任务中心</div>
      <template v-if="dataList">
        <ul class="console__drawer-list" v-if="dataList.length > 0">
          <li class="console__drawer-item" v-for="(item, index) in dataList" :key="index">
            <div class="flex-1">
              <div class="console__drawer-name">{{ index + 1 }}. {{ item.exportName }}</div>
              <div class="console__drawer-status">
                <!--0导出中,1导出成功,2导出失败 isDeleted是否删除 0无效 1有效-->
                <span :class="`console__drawer-status--${item.status}`">{{ item.status | processStatusText }}</span>
                <a
                  class="console__drawer-handle console__drawer-handle--success"
                  v-if="item.status == 1"
                  :href="item.exportUrl"
                >
                  立即下载
                </a>
                <!-- <a
                  class="console__drawer-handle console__drawer-handle--fail"
                  v-if="item.status == 2"
                  :href="item.exportUrl"
                >
                  重新下载
                </a> -->
              </div>
            </div>
          </li>
        </ul>
        <div class="console__drawer-list nodata" v-else>暂无导出任务</div>
      </template>
      <div class="console__drawer-foot">
        <div class="console__drawer-notice">导出文件有效期24小时，过期自动删除</div>
        <a-button class="console__drawer-button" @click.native="onClear">清空已完成任务</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
  import { interfaceOfExportsSecond, interfaceOfExportsDelete } from 'apis/common'

  export default {
    data() {
      return {
        showDrawer: false,
        dataList: null,
        throttled: null,
        isShow: false,
      }
    },
    filters: {
      processStatusText(val) {
        switch (val) {
          case 0:
            return '导出中（文件可能较大，预计等待1-60秒）'
          case 1:
            return '导出成功'
          case 2:
            return '导出失败'
          default:
            return val
        }
      },
    },
    // created() {
    //   console.log('renwuzhognx', this.$store, this.$store.state.listAllPerm.showTaskConsoleDrawer)
    // },
    watch: {
      '$store.state.listAllPerm.showTaskConsoleDrawer': function (val) {
        console.log('--', JSON.stringify(val))
        if (val) {
          this.throttled = this.createThrottle(this.getList, 3000)()
        } else {
          this.throttled && this.throttled.cancel()
        }
      },
      '$store.getters.getUserInfo': function (val) {
        if (val) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      },
    },
    methods: {
      reorganizationHttpsFn(src) {
        return src.slice(0, 4) + 's' + src.slice(4, src.length)
      },
      createThrottle(done, delay) {
        console.log('轮询', done, delay)
        return function () {
          // 先执行一次
          done()

          const intervalID = setInterval(done, delay)

          return {
            cancel() {
              clearInterval(intervalID)
            },
          }
        }
      },
      onShowDrawer() {
        this.$store.dispatch('switchTaskConsoleDrawer', true)
      },
      onClosedDrawer() {
        this.$store.dispatch('switchTaskConsoleDrawer', false)
      },
      getList() {
        console.log('jiekoup')
        /* this.$axios.get('/api/export/exportFile/list', {
         params: {
           pageNum: 1,
           pageSize: 200
         },
         meta:{
           showLoading: false
         }
       }).then(dataRes => {
         if (dataRes.data.type == 'SUCCESS') {
           this.dataList = dataRes.data.data.list

           // 如果不存在下载中，则不轮训
           const hasLoading = this.dataList.some((item)=>{
             console.log('item',item.fileName,item.processStatus)
             return item.processStatus == 0
           })

           !hasLoading && this.throttled && this.throttled.cancel()
         }
       })*/

        interfaceOfExportsSecond().then((res) => {
          console.log('fancan', res)
          this.dataList = res.records

          // 如果不存在下载中，则不轮训
          const hasLoading = this.dataList.some((item) => {
            //  console.log('item',item.fileName,item.processStatus)
            return item.status == 0
          })
          console.log('hasLoading', hasLoading)

          !hasLoading && this.throttled && this.throttled.cancel()
        })
      },
      onClear() {
        /*this.$axios.get('/api/export/exportFile/clearTask').then(dataRes => {
        if (dataRes.data.type == 'SUCCESS') {
          this.$message({
            type: 'success',
            message: '已清空'
          })

          this.getList()
        }
      })*/
        // 0导出中,1导出成功,2导出失败
        let ids = []
        let len = this.dataList.length
        for (let i = 0; i < len; i++) {
          if (this.dataList[i].status == 1 || this.dataList[i].status == 2) {
            ids.push(this.dataList[i].id)
          }
        }
        console.log('清空之前', this.dataList, ids)
        interfaceOfExportsDelete({
          data: {
            ids: ids,
          },
        }).then((res) => {
          // console.log('清空', res)
          this.$message.success('已清空', 10)
          this.getList()
        })
      },
      onRefresh(excelUrl) {
        /*this.$axios.get('/api/export/exportFile/reExport', {
        params: {
          fileId
        }
      }).then(dataRes => {
        if (dataRes.data.type == 'SUCCESS') {
          this.getList()
        }
      })*/
        console.log('重新下载', excelUrl)
        window.open(excelUrl)
        this.getList()
      },
      onDownload(excelUrl) {
        // 打开下载
        /*this.$axios.get('/api/export/exportFile/getExportFilePath', {
        params: {
          fileId
        }
      }).then(dataRes => {
        if (dataRes.data.type == 'SUCCESS') {
          window.open(this.$url + dataRes.data.data.filePath)
        }
      })*/
        console.log('立即下载')
        window.open(excelUrl)
        this.getList()
      },
    },
  }
</script>

<style lang="scss">
  .ant-drawer-body {
    padding: 0;
  }

  .components-task-console {
  }

  .console__drawer {
    .el-drawer__header {
      display: none;
    }
  }

  .flex-1 {
    flex: 1;
  }

  .console {
    &__switch-button {
      position: fixed;
      z-index: 999;
      right: 0;
      bottom: 30%;
      width: 24px;
      text-align: center;
      line-height: 1.3;
      font-size: 18px;
      box-sizing: border-box;
      color: #fff;
      box-shadow: -2px 2px 10px 0 rgba(0, 0, 0, 0.15);
      letter-spacing: 2px;
      padding: 10px 0 10px 4px;
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
      background-color: rgba(46, 51, 247, 0.8);
      transform: translateY(-50%);
      cursor: pointer;
    }

    &__drawer-head {
      margin-top: 10px;
      padding: 10px 10px 10px 12px;
      font-size: 20px;
    }

    &__drawer-list {
      font-size: 18px;
      height: calc(100vh - 140px);
      box-sizing: border-box;
      overflow: auto;
      padding-left: 0;

      &.nodata {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__drawer-item {
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px dotted #eaeff7;
      padding: 10px 12px;
    }

    &__drawer-name {
      flex: 1;
      color: #333;
      line-height: 1.3;
      margin-bottom: 12px;
    }

    &__drawer-status {
      color: red;
      display: flex;
      justify-content: space-between;
    }

    &__drawer-status--0 {
      color: #e6a23c;
    }

    &__drawer-status--1 {
      color: #67c23a;
    }

    &__drawer-status--2 {
      color: #f56c6c;
    }

    &__drawer-handle {
      margin-left: 30px;
      text-decoration: underline;
      cursor: pointer;
    }

    &__drawer-handle--success {
      color: #67c23a;
    }

    &__drawer-handle--fail {
      color: #f56c6c;
    }

    &__drawer-foot {
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    &__drawer-notice {
      color: #c0c4cc;
      margin-bottom: 20px;
      font-size: 18px;
      text-align: center;
    }

    &__drawer-button {
      width: 100%;
      height: 40px;
      border-radius: 0;
      border-bottom: none;
      border-left: none;
      border-right: none;
    }
  }
</style>
